import Hero from '../components/Hero/Hero';
import ServicesCards from '../components/ServicesCards/ServicesCards';
import WhyChooseUs from '../components/WhyChooseUs/WhyChooseUs';
import HowItWorks from '../components/HowItWorks/HowItWorks';
import PaymentOptions from '../components/PaymentOptions/PaymentOptions';
import Reviews from '../components/Reviews/Reviews';
import SEO from '../components/SEO';

const Home = () => {
  return (
    <div>
      <SEO
        title="Home"
        description="Compassionate home health care services in Los Angeles, San Bernardino, Orange, Ventura, and Riverside counties. Licensed and ACHC accredited. Skilled nursing, physical therapy, occupational therapy, speech therapy, and more."
        keywords="home health care, skilled nursing, physical therapy, occupational therapy, speech therapy, Alzheimer's care, senior care, Southern California, Los Angeles, Pasadena"
        canonicalUrl="https://allforyouhc.com"
      />
      <Hero />
      <ServicesCards />
      <WhyChooseUs />
      <HowItWorks />
      <PaymentOptions />
      <Reviews />
    </div>
  );
};

export default Home;
